<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="incrementer-wrapper" [ngClass]="{ printOption: isPrint }">
  <div class="xrx-incrementer icon-button" [ngClass]="{ sm: !isMfd }">
    @if (icon) {
      <span class="xrx-icon-sm" [ngClass]="icon ? icon : 'globe'"></span>
    }
    @if (label) {
      <span class="xrx-label" [xdaTranslate]="label">fff</span>
    }
    <button
      type="button"
      class="xrx-btn btn-secondary icon-button plus xgl-plus"
      (click)="changeValue(true)"></button>
    <button
      type="button"
      class="xrx-btn btn-secondary icon-button minus xgl-minus"
      (click)="changeValue(false)"></button>
    <span class="xrx-value">{{ value }}</span>
  </div>
</div>
